import React, { useCallback, useMemo } from "react";
import DadosSociosPjOutrosProponentesFintechsForm from "./DadosSociosPjOutrosProponentesFintechsForm";
import { useDispatch, useSelector } from "react-redux";
import {
  getPreenchimentoOperacao,
  isAdicionandoParticipantePreenchimento,
  isAtualizandoPreenchimento,
  isGravandoPreenchimentoOperacao,
  isRemovendoParticipantePreenchimento,
} from "../../../../../selectors/operacao.selectors";
import { actions } from "../../../../../actions/operacao.actions";

const DadosSociosPjOutrosProponentesFintechsFormConnected = ({
  setStep,
  setEvents,
  eventsOutrosPj,
  eventsSociosPf,
  eventsSociosPj,
  setParticipante,
  participante,
  outrosProponentes,
  ...otherProps
}) => {
  const dispatch = useDispatch();
  const { operacao } = useSelector(getPreenchimentoOperacao);
  const refreshing = useSelector(isAtualizandoPreenchimento);
  const adding = useSelector(isAdicionandoParticipantePreenchimento);
  const deleting = useSelector(isRemovendoParticipantePreenchimento);
  const submitting = useSelector(isGravandoPreenchimentoOperacao);

  const socios = useMemo(
    () =>
      outrosProponentes.filter((p) => p.participanteOrigem === participante.id),
    [outrosProponentes, participante]
  );

  const handleAdicionarSocio = useCallback(
    (tipoPessoa) => {
      dispatch(
        actions.adicionarParticipantePreenchimento.request({
          id: operacao.id,
          idParticipanteOrigem: participante.id,
          tipoParticipante: "RL",
          tipoPessoa,
        })
      );
    },
    [dispatch, operacao, participante]
  );
  const handleRemoverSocio = useCallback(
    (e, participante) => {
      e.stopPropagation();
      dispatch(
        actions.removerParticipantePreenchimento.request({
          id: operacao.id,
          participante,
        })
      );
    },
    [dispatch, operacao]
  );

  const acessarParticipante = useCallback(
    (p) => {
      setParticipante(p);
      if (p.tipoPessoa === "F") {
        setEvents(eventsSociosPf);
        setStep(60);
      } else if (p.tipoPessoa === "J") {
        setEvents(eventsSociosPj);
        setStep(60);
      }
    },
    [setParticipante, setStep, setEvents, eventsSociosPf, eventsSociosPj]
  );

  const handleAcessarSocio = useCallback(
    (e, c) => {
      e.stopPropagation();
      acessarParticipante(c);
    },
    [acessarParticipante]
  );

  return (
    <DadosSociosPjOutrosProponentesFintechsForm
      {...otherProps}
      submitting={submitting}
      fluxo={participante.fluxo}
      handleAdicionarSocio={handleAdicionarSocio}
      handleRemoverSocio={handleRemoverSocio}
      handleAcessarSocio={handleAcessarSocio}
      events={eventsOutrosPj}
      refreshing={refreshing}
      deleting={deleting}
      adding={adding}
      socios={socios}
    />
  );
};

export default DadosSociosPjOutrosProponentesFintechsFormConnected;
